import React, { useState } from "react";

export default function WeatherTemperature(props) {
  const [unit, setUnit] = useState("celsius");
  function showFahrenheit(event) {
    event.preventDefault();
    setUnit("fahrenheit");
  }
  function showCelsius(event) {
    event.preventDefault();
    setUnit("celsius");
  }
  if (unit === "celsius") {
    return (
      <div>
        <strong>
          <span id="currentTemperature">{Math.round(props.celsius)}</span>{" "}
        </strong>{" "}
        <sup>
          <small className="units">
            °C |{" "}
            <a href="/" onClick={showFahrenheit}>
              °F
            </a>
          </small>
        </sup>{" "}
      </div>
    );
  } else {
    let fahrenheit = (props.celsius * 9) / 5 + 32;
    return (
      <div>
        <strong>
          <span id="currentTemperature">{Math.round(fahrenheit)}</span>{" "}
        </strong>{" "}
        <sup>
          <small className="units">
            <a href="/" onClick={showCelsius}>
              °C{" "}
            </a>
            | °F
          </small>
        </sup>{" "}
      </div>
    );
  }
}
